var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomePhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "64.000000pt",
    height: "64.000000pt",
    viewBox: "0 0 64.000000 64.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,64.000000) scale(0.100000,-0.100000)",
    fill: "#ffffff",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M255 580 l-60 -61 -5 28 c-5 25 -10 28 -49 31 -28 2 -47 -1 -52 -10 -5 -7 -9 -47 -9 -88 0 -74 0 -75 -42 -117 -33 -34 -39 -46 -30 -55 10 -10 43 18 155 130 78 78 149 142 157 142 8 0 79 -64 157 -142 113 -113 145 -140 155 -130 10 10 -20 45 -147 172 -88 88 -162 160 -165 160 -3 0 -32 -27 -65 -60z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197 412 l-127 -127 0 -122 0 -122 -32 -3 c-21 -2 -33 -8 -33 -18 0 -13 42 -15 315 -15 273 0 315 2 315 15 0 10 -12 16 -32 18 l-33 3 0 127 0 127 -123 123 -122 122 -128 -128z m89 -73 c16 -25 24 -49 20 -63 -9 -37 58 -98 81 -75 11 11 83 -27 98 -51 9 -15 -42 -69 -71 -76 -27 -7 -98 23 -142 61 -41 34 -92 121 -92 156 0 27 48 89 69 89 6 0 22 -18 37 -41z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232 318 c-20 -20 -14 -52 18 -100 49 -74 142 -126 175 -98 22 19 1 38 -39 37 -19 0 -46 7 -60 17 -36 23 -68 76 -61 102 7 29 -16 59 -33 42z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomePhone);
export default __webpack_public_path__ + "static/media/HomePhone.78a4d1c82603743bda57467528d5521d.svg";
export { ForwardRef as ReactComponent };